/* eslint-disable */
import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import Datetime from 'react-datetime'
import { default as moment } from 'moment-timezone'
import ReactHtmlParser from 'react-html-parser'
import { ContentHeader, StaticBox, FlowTable, LinkedInput, LinkedInputGroup, Modal, NoContentBox } from 'components/basic'
import { notify, date, FormHelper } from 'helpers'
import { Installation } from 'config'
import http from 'API/http'

class Access23 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      deactivationDate: null,
      activationDate: null,
      changeDate: null,
      serviceToDisconnect: {},
      serviceToConnect: {},
      serviceToEdit: {},
      serviceToChange: {},
      loadingLink: false,
      connectionModal: false,
      editModal: false,
      troubleModal: false,
      linkStatus: false,
      spReference: '',
      tickets: [],
      orders: false,
      activating: false,
      fetchingAccess: false
    }
    this.interval = null
  }

  componentDidMount () {
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
    this.setState({linkStatus: null})
    this.interval = setInterval(() => {
      this.getAccess()
    }, 10000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  async componentWillReceiveProps (nextProps) {
    if (this.props.match.params.accessid === nextProps.match.params.accessid) return false
    this.setState({fetchingAccess: true})
    this.getAccess(nextProps.match.params.accessid)
    this.getTickets(nextProps.match.params.accessid)
    this.setState({linkStatus: null})
  }

  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }

  async getTickets (accessId) {
    if (!accessId) accessId = this.props.match.params.accessid
    var err, res
    [err, res] = await http.get('2.3/accesses/' + accessId + '/tickets')
    if (err) return notify.alert('', err.message, 'error')
    this.setState({tickets: res.data})
  }

  async getAccess (accessId) {
    if (!accessId) accessId = this.props.match.params.accessid
    var err, res
    [err, res] = await http.get('2.3/accesses/' + accessId)
    if (err) {
      this.setState({fetchingAccess: false})
      return notify.alert('', err.message, 'error')
    }

    this.setState({ access: res.data, fetchingAccess: false })
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: `${res.data.streetName} ${res.data.streetNumber}`
    })
  }

  async getLinkStatus () {
    this.setState({loadingLink: true, troubleModal: true})
    var err, res
    [err, res] = await http.get('2.3/accesses/' + this.state.access.accessId + '/link')
    if (err) {
      this.setState({loadingLink: false, troubleModal: false})
      return notify.alert('', 'Unable to get link status, Contact ISP for more information.', 'error')
    }
    this.setState({loadingLink: false, linkStatus: res.data})
  }

  isDateValidActivate (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    if (this.state.serviceToConnect.available !== 'YES' && this.state.serviceToConnect.available !== 'NO') {
      return current.isSameOrAfter(moment(this.state.serviceToConnect.available))
    }
    return current.isAfter(yesterday)
  }

  isDateValid (current) {
    var yesterday = Datetime.moment().subtract(1, 'day')
    return current.isAfter(yesterday)
  }

  async deactivateService () {
    this.setState({activating: true})
    var err
    err = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToDisconnect.service,
      operation: 'DEACTIVATE',
      operationTime: (!this.state.deactivationDate ? null : this.state.deactivationDate.unix())
    })[0]
    if (err) return notify.alert('', err.message, 'error')
    this.setState({modalState: false, activating: false})
    notify.alert('', 'The service will be deactivated ' + (!this.state.deactivationDate ? 'soon.' : moment(this.state.deactivationDate).format('YYYY-MM-DD')), 'success')
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
  }

  async changeService () {
    this.setState({activating: true})
    console.log(this.state.serviceToChange)
    var [err, res] = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToChange.service,
      operationTime: (!this.state.serviceToChange.changeDate ? null : this.state.serviceToChange.changeDate.unix()),
      operation: 'DEACTIVATE'
    })
    if (err) return notify.alert('', err.message, 'error')
    console.log('Change Date: ', this.state.serviceToChange.changeDate)
    console.log('Change Date - Unix: ', this.state.serviceToChange.changeDate)
    var [err, res] = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToConnect.service,
      operationTime: (!this.state.serviceToChange.changeDate ? (moment().add(30, 'seconds')).unix() : (this.state.serviceToChange.changeDate.unix() + 30)),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: this.state.serviceToChange.spReference,
      deliveryAddress: {
        smsNotificationPhone: '',
        streetName: this.state.access.streetName,
        streetNumber: this.state.access.streetNumber,
        streetLittera: this.state.access.streetLittera,
        zipCode: this.state.access.postalCode,
        city: this.state.access.city
      }
    })
    if (err) return notify.alert('', err.message, 'error')
    this.setState({modalState: false, activating: false, changeModal: false})
    notify.alert('', 'The switch will be performed ' + (!this.state.serviceToChange.changeDate ? 'soon.' : moment(this.state.serviceToChange.changeDate).format('YYYY-MM-DD')), 'success')
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
  }

  async activateService () {
    var [err, res] = await http.get('2.3/orders/' + this.state.access.accessId + '/validate')
    var valid = await FormHelper.validate(this.form)
    if (!valid) return
    this.setState({activating: true})
    var err, res
    [err, res] = await http.post('2.3/orders', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToConnect.service,
      operationTime: (!this.state.activationDate ? null : this.state.activationDate.unix()),
      operation: 'ACTIVATE',
      forcedTakeover: false,
      equipment: [
        { vendorId: 'CH_BROADBAND' }
      ],
      spReference: this.state.spReference,
      deliveryAddress: {
        smsNotificationPhone: '',
        streetName: this.state.access.streetName,
        streetNumber: this.state.access.streetNumber,
        streetLittera: this.state.access.streetLittera,
        zipCode: this.state.access.postalCode,
        city: this.state.access.city
      }
    })
    var activationDate = this.state.activationDate
    this.setState({
      activationDate: null,
      serviceToConnect: {},
      connectionModal: false,
      spReference: '',
      activating: false
    })
    if (err) return notify.alert('', err.response.data.cause, 'error')
    notify.alert('', 'The service will be activated ' + (!activationDate ? 'soon.' : moment(activationDate).format('YYYY-MM-DD HH:mm')), 'success')
    this.getAccess(this.props.match.params.accessid)
    this.getTickets(this.props.match.params.accessid)
  }

  getServiceAvailability (availability) {
    if (availability === 'YES') return <i className='fa fa-fw fa-check-circle text-success' />
    if (availability === 'NO') return <i className='fa fa-fw fa-times-circle text-danger' />
    return <span className='label label-primary'>{date.format(availability)}</span>
  }

  async openConnectionModal (service) {
    await http.get('2.3/accesses/' + this.state.access.accessId + '/availability')
    this.setState({serviceToConnect: service, connectionModal: true})
    if (service.available !== 'YES' && service.available !== 'NO') this.setState({activationDate: moment(service.available)})
  }

  editReference (service) {
    this.setState({serviceToEdit: {...service, activationDate: service.activationDate * 1000, deactivationDate: service.deactivationDate * 1000}, editModal: true})
  }

  changeReference (service) {
    this.setState({serviceToChange: {...service, activationDate: service.activationDate * 1000, deactivationDate: service.deactivationDate * 1000}, changeModal: true})
  }

  async saveServiceReference () {
    this.setState({activating: true})
    var err, res
    [err, res] = await http.post('2.3/accesses/' + this.state.access.accessId + '/service', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToEdit.service,
      spReference: this.state.serviceToEdit.spReference,
      activationDate: this.state.serviceToEdit.activationDate ? moment(this.state.serviceToEdit.activationDate).unix() : null,
      deactivationDate: this.state.serviceToEdit.deactivationDate ? moment(this.state.serviceToEdit.deactivationDate).unix() : null
    })
    if (err) return notify.warn('Could not update service')
    notify.success(this.state.serviceToEdit.service + ' has been updated.')
    this.setState({serviceToEdit: {}, editModal: false, activating: false})
  }

  async deleteService () {
    this.setState({activating: true})
    var err, res
    [err, res] = await http.post('2.3/accesses/' + this.state.access.accessId + '/service/delete', {
      accessId: this.state.access.accessId,
      service: this.state.serviceToEdit.service
    })
    if (err) return notify.warn('Could not delete service')
    notify.success(this.state.serviceToEdit.service + ' has been deleted.')
    this.setState({serviceToEdit: {}, editModal: false, activating: false})
  }

  static arrayEqual (a, b) {
    let l = a.length
    if (l !== b.length) {
      return false
    }
    while (--l) {
      console.debug(l)
      if (a[l] !== b[l]) {
        return false
      }
    }
    return true
  }
  static isTable (a) {
    if (!Array.isArray(a)) {
      return false
    }
    if (a.length === 0) {
      return false
    }

    if (typeof a[0] !== 'object') {
      return false
    }
    let headers = Object.keys(a[0])
    let l = headers.length
    while (l--) {
      if (!['string', 'number'].includes(typeof headers[l])) {
        return false
      }
    }

    l = a.length
    while (l--) {
      if (!Access23.arrayEqual(headers, Object.keys(a[l]))) {
        return false
      }
      let values = Object.values(a[l])
      let x = values.length

      while (x--) {
        if (!['string', 'number'].includes(typeof values[x])) {
          return false
        }
      }
    }
    return true
  }

  renderLinkStatus (children, count, level) {
    if (!children) return null
    if (!count) count = 0
    if (!level) level = 0
    let buffer = []
    level++
    for (let key in children) {
      if (!children.hasOwnProperty(key)) {
        continue
      }
      count++
      let value = children[key]
      if (['string', 'number'].includes(typeof value)) {
        buffer.push(<div className={(level === 1 ? 'col-md-12' : 'margin-left-10')} key={count}><span><b>{key}</b>: <small>{value}</small></span></div>)
      } else if (['boolean'].includes(typeof value)) {
        buffer.push(<div className={(level === 1 ? 'col-md-12' : 'margin-left-10')} key={count}><span><b>{key}</b>: <small>{(value ? <i className='fa fa-check-circle text-success' /> : <i className='fa fa-times-circle text-danger' />)}</small></span></div>)
      } else if (Access23.isTable(value)) {
        buffer.push(<div className={(level === 1 ? 'col-md-12' : 'margin-left-10')} key={count}>
          <span><b>{key}</b> <i className='fa fa-rotate-90 fa-mail-forward' /></span>
          <pre>
            <FlowTable data={value.map(row => Object.values(row))}>
              <tr>
                {Object.keys(value[0]).map(key => <th key={count + '_' + key}>{key}</th>)}
              </tr>
            </FlowTable>
          </pre>
        </div>)
      } else {
        buffer.push(<div className={(level === 1 ? 'col-md-12' : 'margin-left-10')} key={count}><span>{key}</span> {this.renderLinkStatus(value, count, level)}</div>)
      }
    }
    return buffer
  }

  render () {
    if (!this.state.access) return null
    console.log('Props', this.props)
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle={`${this.state.access.streetName} ${this.state.access.streetNumber}`} buttons={[ { icon: 'fa-arrow-left', event: () => (window.location.hash = '/access') } ]} />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='home' title={`${this.state.access.streetName} ${this.state.access.streetNumber}`}>
            <div className='row'>
              <div className='col-md-4'>
                <label>Street</label>
                <LinkedInput context={this} editable={false} path='access.streetName' />
              </div>
              <div className='col-md-2'>
                <label>Number</label>
                <LinkedInput context={this} editable={false} path='access.streetNumber' />
              </div>
              <div className='col-md-2'>
                <label>Littera</label>
                <LinkedInput context={this} editable={false} path='access.streetLittera' />
              </div>
              <div className='col-md-2'>
                <label>Zipcode</label>
                <LinkedInput context={this} editable={false} path='access.postalCode' />
              </div>
              <div className='col-md-2'>
                <label>City</label>
                <LinkedInput context={this} editable={false} path='access.city' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-2'>
                <label>Apartment Number</label>
                <LinkedInput context={this} editable={false} path='access.mduApartmentNumber' />
              </div>
              <div className='col-md-2'>
                <label>Apartment Address</label>
                <LinkedInput context={this} editable={false} path='access.mduDistinguisher' />
              </div>
              <div className='col-md-2'>
                <label>Population</label>
                <LinkedInput context={this} editable={false} path='access.population' />
              </div>
              <div className='col-md-2'>
                <label>Premises Type</label>
                <LinkedInput context={this} editable={false} path='access.premisesType' />
              </div>
              <div className='col-md-2'>
                <label>Access ID</label>
                <LinkedInput context={this} editable={false} path='access.accessId' />
              </div>
            </div>
          </StaticBox>
        </div>
        <div className='row'>
          <StaticBox cols={12} icon='cog' title='Services'>
            {this.props.access !== 'FLOW' &&
              <FlowTable data={this.state.access.active.map(service => [
                ((service.status === 'ACTIVE' || this.props.access !== 'FLOW' ) ? <a onClick={e => this.setState({serviceToDisconnect: service, modalState: true})} className='table-link'><i className='fa fa-remove' /></a> : ''),
                <a className='table-link' onClick={e => this.editReference(service)}><i className='fa fa-pencil' /></a>,
                ((service.status === 'ACTIVE' ) ? <a className='table-link' onClick={e => this.changeReference(service)}><i className='fa fa-exchange' /></a> : ''),
                ((service.status === 'ACTIVE' || (this.props.access !== 'FLOW' && (new Date() >= new Date(service.activationDate*1000)))) ? <span className='label label-success'>ACTIVE</span> : <span className='label label-primary'>PENDING</span>),
                service.service,
                service.spReference,
                service.option82,
                (!service.activationDate ? '' : date.format(service.activationDate * 1000)),
                service.deactivationDate ? date.format(service.deactivationDate * 1000) : '',
                Installation.enable.tickets ? <a onClick={e => (window.location = ('/#/ticket/create/' + this.state.access.accessId + '/' + window.btoa(service.service)))} className='table-link'><i className='fa fa-plus' /></a> : <i className='fa fa-ban text-muted' />])}>
                <tr>
                  <th className='buttons' />
                  <th className='buttons' />
                  <th className='buttons' />
                  <th className='buttons' />
                  <th>Service</th>
                  <th>Your Internal Reference</th>
                  <th>Option 82</th>
                  <th>Activation Date</th>
                  <th>Deactivation Date</th>
                  <th className={(!Installation.enable.tickets ? 'text-muted' : '')}>Trouble Ticket</th>
                </tr>
              </FlowTable>
              }
              {this.props.access === 'FLOW' &&
              <FlowTable data={this.state.access.active.map(service => [
                <a className='table-link' onClick={e => this.editReference(service)}><i className='fa fa-pencil' /></a>,
                (service.status === 'ACTIVE' ? <a className='table-link' onClick={e => this.changeReference(service)}><i className='fa fa-exchange' /></a> : ''),
                ((service.status === 'ACTIVE' || this.props.access !== 'FLOW') ? <span className='label label-success'>ACTIVE</span> : <span className='label label-primary'>PENDING</span>),
                service.service,
                service.spReference,
                service.option82,
                (!service.activationDate ? '' : date.format(service.activationDate * 1000)),
                service.deactivationDate ? date.format(service.deactivationDate * 1000) : '',
                Installation.enable.tickets ? <a onClick={e => (window.location = ('/#/ticket/create/' + this.state.access.accessId + '/' + window.btoa(service.service)))} className='table-link'><i className='fa fa-plus' /></a> : <i className='fa fa-ban text-muted' />])}>
                <tr>
                  <th className='buttons' />
                  <th className='buttons' />
                  <th className='buttons' />
                  <th>Service</th>
                  <th>Your Internal Reference</th>
                  <th>Option 82</th>
                  <th>Activation Date</th>
                  <th>Deactivation Date</th>
                  <th className={(!Installation.enable.tickets ? 'text-muted' : '')}>Trouble Ticket</th>
                </tr>
              </FlowTable>
              }
          </StaticBox>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='row'>
              <StaticBox cols={12} icon='cog' title='Available Services'>
                <FlowTable loading={this.state.fetchingAccess} data={this.state.access.services.map(service => [
                  (service.available !== 'NO' && <a onClick={e => this.openConnectionModal(service)} className='table-link'><i className='fa fa-plus' /></a>),
                  this.getServiceAvailability(service.available),
                  service.service])}>
                  <tr>
                    <th className='buttons' />
                    <th className='buttons'>Available</th>
                    <th>Name</th>
                  </tr>
                </FlowTable>
              </StaticBox>
              {Installation.enable.troubleshooting && <StaticBox icon='heartbeat' title='Troubleshooting' buttons={[
                {icon: 'fa-play', event: e => this.getLinkStatus('test')}
              ]}>
                <div className='col-md-12'>
                  {this.state.loadingLink &&
                  <h1 className='text-center'><i className='fa fa-fw fa-spin fa-cog' /></h1>
                  }
                  {this.state.linkStatus &&
                  this.renderLinkStatus(this.state.linkStatus)
                  }
                </div>
              </StaticBox>}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='row'>
              {Installation.enable.tickets && <StaticBox cols={12} icon='comments-o' title='Trouble Tickets' buttons={[{icon: 'fa-plus', event: e => (window.location = '/#/ticket/create/' + this.state.access.accessId)}]}>
                <FlowTable paginatable={10} data={this.state.tickets.map(ticket => [<a href={'/#/ticket/' + ticket.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>, ReactHtmlParser(ticket.title), ticket.ticketRef, this.getStatus(ticket.state.status)])}>
                  <tr>
                    <th className='buttons' />
                    <th>Title</th>
                    <th>ID</th>
                    <th>Status</th>
                  </tr>
                </FlowTable>
              </StaticBox>}
            </div>
          </div>
        </div>
        <Modal noOverflow title={'Disconnect ' + this.state.serviceToDisconnect.service} isOpen={this.state.modalState} close={e => this.setState({modalState: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({modalState: false, serviceToDisconnect: {}}) },
            { text: 'Disconnect', event: e => this.deactivateService(), hidden: this.state.activating }
        ]}>
          <label>Deactivation time</label>
          <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.deactivationDate} onChange={date => {
            this.setState({deactivationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>

        <Modal noOverflow title={'Connect ' + this.state.serviceToConnect.service} isOpen={this.state.connectionModal} close={e => this.setState({connectionModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({connectionModal: false, connect: {}}), hidden: this.state.activating },
            { text: 'Connect', event: e => this.activateService(), hidden: this.state.activating }
        ]}>
          <label>Activation time</label>
          <Datetime isValidDate={this.isDateValidActivate.bind(this)} value={this.state.activationDate} onChange={date => {
            this.setState({activationDate: date})
          }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'As soon as possible.'}} timeFormat={'HH:mm'} renderInput={props =>
            <div className='input-group'>
              <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
              <input {...props} className='form-control' />
            </div>
          } />
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='spReference' />
              </div>
            </div>
          </LinkedInputGroup>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>

        <Modal noOverflow title={'Edit ' + this.state.serviceToEdit.service} isOpen={this.state.editModal} close={e => this.setState({editModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({editModal: false, serviceToEdit: {}}) },
            { text: 'Save', event: e => this.saveServiceReference(), hidden: this.state.activating },
            { text: 'Delete', event: e => this.deleteService(), hidden: ((this.props.access !== 'FLOW') || this.state.serviceToEdit.status === 'ACTIVE' || this.state.activating) }
        ]}>
          <LinkedInputGroup ref={(form) => { this.editForm = form }}>
            {!!this.state.serviceToEdit.activationDate &&
              <div className='row'>
                <div className='form-group col-md-12'>
                  <label>Activation Date</label>
                  <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.serviceToEdit.activationDate} onChange={date => {
                    this.setState({serviceToEdit: {...this.state.serviceToEdit, activationDate: date}})
                  }} dateFormat={'YYYY-MM-DD'} inputProps={Object.assign({placeholder: 'Select a date.'}, this.state.serviceToEdit.status !== 'PENDING' ? {disabled: 'disabled'} : null)} timeFormat={'HH:mm'} renderInput={props =>
                    <div className='input-group'>
                      <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                      <input {...props} className='form-control' />
                    </div>
                  } />
                </div>
              </div>
            }
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Deactivation Date</label>
                  <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.serviceToEdit.deactivationDate} onChange={date => {
                    this.setState({serviceToEdit: {...this.state.serviceToEdit, deactivationDate: date}})
                  }} dateFormat={'YYYY-MM-DD'} inputProps={Object.assign({placeholder: 'Select a date.'}, this.state.serviceToEdit.status !== 'ACTIVE' ? {disabled: 'disabled'} : null)} timeFormat={'HH:mm'} renderInput={props =>
                    <div className='input-group'>
                      <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                      <input {...props} className='form-control' />
                      <span className='input-group-btn'>
                        <button className='btn btn-danger' type='button'
                          onClick={() => (this.setState({serviceToEdit: {...this.state.serviceToEdit, deactivationDate: null}}))}><i className='fa fa-trash-o' />
                        </button>
                      </span>
                    </div>
                  } />
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='serviceToEdit.spReference' />
              </div>
            </div>
          </LinkedInputGroup>
          {this.state.activating && <NoContentBox icon='circle-o-notch fa-spin' text='' />}
        </Modal>

        <Modal noOverflow title={'Change ' + this.state.serviceToChange.service} isOpen={this.state.changeModal} close={e => this.setState({changeModal: false})} buttons={[
            { text: 'Cancel', event: e => this.setState({changeModal: false, serviceToChange: {}}) },
            { text: 'Save', event: e => this.changeService(), hidden: this.state.activating }
        ]}>
          <LinkedInputGroup ref={(form) => { this.editForm = form }}>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Date to switch service</label>
                <Datetime isValidDate={this.isDateValid.bind(this)} value={this.state.serviceToChange.changeDate} onChange={date => {
                  this.setState({serviceToChange: {...this.state.serviceToChange, changeDate: date}})
                }} dateFormat={'YYYY-MM-DD'} inputProps={{placeholder: 'Select a date'}} timeFormat={'HH:mm'} renderInput={props =>
                  <div className='input-group'>
                    <span className='input-group-addon'><i className='fa fa-fw fa-calendar' /></span>
                    <input {...props} className='form-control' />
                  </div>
                } />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>New service</label>
                <Select
                  value={this.state.serviceToConnect}
                  onChange={e => this.setState({serviceToConnect: e})}
                  options={this.state.access.services.filter(s => ((s.productGroup_id === this.state.serviceToChange.productGroup_id || !s.productGroup_id) && s.service !== this.state.serviceToChange.service))}
                  valueKey='service'
                  labelKey='service'
                  clearable={false}
                />
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-md-12'>
                <label>Your Internal Reference</label>
                <LinkedInput validate={/.{1,}/} errorMessage='This field is required' context={this} path='serviceToChange.spReference' />
              </div>
            </div>
          </LinkedInputGroup>
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
Access23 = connect(state => state.siteReducer)(Access23)
export default Access23



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/access/access.js